module.exports = __webpack_public_path__ + "static/img/productCenterBanner.51b975a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenterBanner.png
// module id = NCJI
// module chunks = 1